import * as yup from "yup";

const reminderPreferencesChangeReasonSchema = yup.object().shape({
  ChangeReasonID: yup.number().required("Reason for change is required"),
  Comment: yup.string().nullable().max(100, "Comment must be at most 100 characters"),
});

export default reminderPreferencesChangeReasonSchema;
